<template>
    <div class="password-reset">
        <div v-if="!emailSent" class="columns is-multiline">
            <div class="column is-full mb-1">
                <h1 class="mx-auto text-center">Reset your password</h1>
            </div>
            <div class="column is-4 mx-auto">
                <!--            @todo convert into a component -->
                <div v-if="errors" class="errors mb-2">
                    <template v-for="(item) in errors">
                        <template v-if="Array.isArray(item)">
                            <div v-for="(error) in item" class="error">{{error}}</div>
                        </template>
                        <template v-else>
                            <div class="error">{{item}}</div>
                        </template>
                    </template>
                </div>
                <form role="form" method="POST"
                      class="form d-flex flex-column justify-content-center" @submit.prevent="submit">
                    <input type="hidden" :value="csrfToken" name="_token"/>
                    <input type="hidden" name="token" :value="token">

                    <div class="field mb-6" :class="{ 'has-error': $v.email.$error }">
                        <label class="label mb-1" for="email">Email Address*</label>
                        <div class="control">
                            <input v-model.trim="$v.email.$model" name="email" id="email" class="input" type="email"
                                   autofocus>
                        </div>
                        <div class="error" v-if="$v.$dirty && $v.email.$invalid">{{emailErrorMessage}}</div>
                    </div>

                    <div class="field mb-5">
                        <label class="label mb-1" for="password">Password*</label>
                        <div class="control">
                            <input v-model.trim="$v.password.$model" id="password" name="password" class="input"
                                   type="password">
                        </div>
                    </div>

                    <div class="field mb-5">
                        <label class="label mb-1" for="passwordConfirmation">Confirm Password*</label>
                        <div class="control">
                            <input v-model.trim="$v.passwordConfirmation.$model" id="passwordConfirmation"
                                   name="password_confirmation" class="input"
                                   type="password">
                        </div>
                    </div>

                    <div class="field mb-3 mx-auto">
                        <button v-if="!loading" type="submit" @click.prevent="submit" class="btn btn-form">Reset your
                            password
                        </button>
                        <pulse-loader v-if="loading" :loading="true" :color="'#E57722'" :size="'20px'"></pulse-loader>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="emailSent" class="notification columns is-multiline">
            <div class="column d-flex justify-content-center mb-1">
                <img class="icon__email-sent" src="/img/icons/email-sent.svg" alt="Email icon"/>
            </div>
            <div class="column is-full mb-1">
                <h1 class="w-872 mx-auto text-center">Check your email to reset your password!</h1>
            </div>
            <div class="column is-full mb-4">
                <p class="w-648 t-black mx-auto text-center">We’ve sent an email to <span class="font-weight-bold">{{email}}</span>
                    where you’ll be able to click the reset link and create a new password for your account.</p>
            </div>
        </div>
    </div>
</template>

<script>

    import {axiosApi} from "@/js/axios";
    import {required, email} from 'vuelidate/lib/validators';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import {axiosWeb} from "@/js/axios";

    //@todo display server validation error

    export default {
        name: 'CatUxoFormPasswordsReset',
        props: {
            loading: false,
            token: {
                type: String,
                default: '',
                required: true
            }
        },
        components: {
            PulseLoader,
        },
        data: function () {
            return {
                csrfToken: null,
                emailSent: false,
                email: '',
                password: '',
                passwordConfirmation: '',
                submitStatus: null,
                errors: []
            }
        },
        computed: {
            emailErrorMessage() {
                if (!this.$v.email.required) {
                    return 'Field is required';
                }

                if (!this.$v.email.email) {
                    return 'Email address is not correct.'
                }
            }
        },
        methods: {
            submit() {
                let $this = this;

                $this.loading = true;
                $this.$v.$touch();

                if ($this.$v.$invalid) {
                    $this.loading = false;
                } else {
                    axiosWeb.post('/password/reset', {
                        token: $this.token,
                        email: $this.email,
                        password: $this.password,
                        password_confirmation: $this.passwordConfirmation
                    }).then(response => {
                        $this.loading = false;

                        window.open('/settings/profile', '_self');
                    }).catch(error => {
                        $this.loading = false;

                        if (error.response.status === 422) {
                            $this.errors = error.response.data.errors;
                        }

                        if (error.response.status === 500) {
                            $this.errors.push(error.response.data);
                        }
                    });
                }
            }
        },
        validations: {
            email: {
                required: required,
                email: email
            },
            password: {
                required
            },
            passwordConfirmation: {
                required
            }
        },
        created() {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        },
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/forms/passwords/Reset.vue